import { createPortfolioPosition } from "../contracts/portfolioPosition";
import {
  calculateCoverageRatio,
  calculateExpectedLossReduction,
  calculateRetainedLoss,
  calculateTotalRiskCost,
} from "../metrics/portfolioMetrics";

export function analyzePortfolioPosition(input = {}) {
  const exposure = input?.exposure ?? {};
  const mitigation = input?.mitigation ?? {};
  const transfer = input?.transfer ?? {};
  const coverage = input?.coverage ?? {};
  const metadata = input?.metadata ?? {};

  const expectedLossReduction = calculateExpectedLossReduction(
    exposure.grossEal,
    mitigation.residualEalBeforeTransfer
  );
  const expectedRetainedLoss = calculateRetainedLoss(
    mitigation.residualEalBeforeTransfer,
    transfer.expectedTransferredLoss
  );
  const totalRiskCost = calculateTotalRiskCost({
    mitigationCost: mitigation.annualInvestment ?? null,
    transferCost: transfer.annualPremium ?? null,
    retainedLoss: expectedRetainedLoss,
  });
  const coverageRatio = calculateCoverageRatio(
    coverage.coveredScenarios,
    coverage.activeScenarios
  );

  return createPortfolioPosition({
    exposure: {
      grossEal: exposure.grossEal ?? null,
      grossP95: exposure.grossP95 ?? null,
      grossP99: exposure.grossP99 ?? null,
    },
    mitigation: {
      annualInvestment: mitigation.annualInvestment ?? null,
      expectedLossReduction,
      residualEalBeforeTransfer: mitigation.residualEalBeforeTransfer ?? null,
      residualP95BeforeTransfer: mitigation.residualP95BeforeTransfer ?? null,
    },
    transfer: {
      annualPremium: transfer.annualPremium ?? null,
      deductible: transfer.deductible ?? null,
      policyLimit: transfer.policyLimit ?? null,
      coinsurance: transfer.coinsurance ?? null,
      expectedTransferredLoss: transfer.expectedTransferredLoss ?? null,
    },
    retained: {
      expectedRetainedLoss,
      retainedP95: null,
      retainedP99: null,
    },
    residual: {
      expectedAnnualLoss: expectedRetainedLoss,
      capitalAtRiskP95: null,
      capitalAtRiskP99: null,
    },
    capital: {
      mitigationCost: mitigation.annualInvestment ?? null,
      transferCost: transfer.annualPremium ?? null,
      retainedCapital: null,
      totalRiskCost,
    },
    coverage: {
      activeScenarios: coverage.activeScenarios ?? null,
      coveredScenarios: coverage.coveredScenarios ?? null,
      uncoveredScenarios: coverage.uncoveredScenarios ?? null,
      activeCoverages: coverage.activeCoverages ?? null,
      expiringCoverages: coverage.expiringCoverages ?? null,
      coverageRatio,
    },
    metadata: {
      currency: metadata.currency ?? null,
      simulations: metadata.simulations ?? null,
      generatedAt: metadata.generatedAt ?? null,
      source: metadata.source ?? null,
    },
  });
}
